import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";

export const RegisterNotification = async(uid, tid) => {
    const publicVapidkey = 'BD5r0z_f1xleKZwG5wYsun8u15G4uIVFtF9OrckvxnBfKDpSSIIaPMPZE3-MtN3oa-ns4aalEdy-Gz6k7Mgkz3Y'; 
    const register = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`, {scope:'/'}); 
    
    function urlBase64ToUint8Array(base64String) { 
        const padding = '='.repeat((4 - base64String.length % 4) % 4); 
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/'); 
        const rawData = window.atob(base64); 
        const outputArray = new Uint8Array(rawData.length); 
        for (let i = 0; i < rawData.length; ++i) { 
            outputArray[i] = rawData.charCodeAt(i); 
        }         
        return outputArray; 
    } 

    console.log(Notification.permission) 
    await register.pushManager.subscribe({ 
        userVisibleOnly: true,  
        applicationServerKey: urlBase64ToUint8Array(publicVapidkey) 
    }).then(async(response) => { 
        const r = JSON.parse(JSON.stringify(response))         
        await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/notification/save`, {user_id : uid, tool_id:tid, endpoint:r.endpoint, p256dh:r.keys.p256dh, auth:r.keys.auth, content_encoding:''} ) 
    }).catch((err) => { 
        return err 
    }) 

    return { 
        'msg':'success' 
    } 
} 